import confirm from "./confirm.vue"
import msg from "./msg.vue"
import toast from "./toast.vue"
import loading from "./loading.vue"
import dialog from "./dialog.vue"
import Vue from "vue"
function Created(alert,opts){
	//var createNode;
	//创建虚拟节点
	var vm = new Vue({
		render: function(h){
			//获取 创建方法
			//createNode = h;
			return h(alert,{props:opts})
		}
	}).$mount()
	//加入到body中
	document.body.appendChild(vm.$el);
	//销毁组件 vm下仅有一个组件
	var alertVue = vm.$children[0];
	return alertVue;
}
function $alert (opts){
	return Created(alert,opts)
}
//静态方法
let loaded = null;
$alert.loading = function(show,options){
	//loading弹窗
	if(!loaded){
		loaded = Created(loading,{options});
		loaded.show = show;
	}else{
		loaded.show = show;
		loaded.options = options;
	}	
	return loaded;
}
$alert.msg = function(content,options,duration){
	//成功弹窗	
	/* 
	1、msg 弹窗内容
	2、duration 自动关闭延时
	3、onClose 自动关闭回调
	*/
    if(typeof options === "number"){
		//如果第二个参数设置为函数，则第三个参数为时间
		var tmp = duration;
			duration = options;
			options = tmp;
	}
	return Created(msg,{msg:content,show:true,duration:duration,options:options});
}
$alert.toast = function(content,options,duration){
	//成功弹窗	
	/* 
	1、msg 弹窗内容
	2、duration 自动关闭延时
	3、onClose 自动关闭回调
	*/
    if(typeof options === "number"){
		//如果第二个参数设置为函数，则第三个参数为时间
		var tmp = duration;
			duration = options;
			options = tmp;
	}
	return Created(toast,{msg:content,show:true,duration:duration,options:options});
}
$alert.confirm = function(options,onClose){
	//有确认按钮
	/*
	可以多个按钮
	*/
   return Created(confirm,{show:true,onClose:onClose,options:options});
}
$alert.dialog = function(options,event,onClose){	
	return Created(dialog,{show:true,event:event,onClose:onClose,options:options})
}
export default {
	install: function(Vue){
		Vue.prototype.$alert = $alert;
		Vue.component('confirmModal', confirm)
	}
}